module.exports = __webpack_public_path__ + "static/media/tooltips_d_013.movie.b267ce06.mp4";